import { reactive, watch, type WatchSource } from 'vue';

import { getSupportedLocales } from '@/plugins/i18n';
import type { Locales } from '@/services/types/api.types';

export type LocaleValidation = {
  [Locale in Locales]?: boolean;
};

export function useLanguageValidationErrors(errors: WatchSource): LocaleValidation {
  const localeErrors = reactive<LocaleValidation>({});
  watch(
    errors,
    (value: Record<Locales, string>) => {
      getSupportedLocales().forEach((locale) => {
        localeErrors[locale] = Object.keys(value).some((x) => x.endsWith(`.${locale}`));
      });
    },
    { deep: true },
  );
  return localeErrors;
}
